// extracted by mini-css-extract-plugin
export default {"container":"GadgetScreenshotInfo_container__q+egG","card":"GadgetScreenshotInfo_card__68vwc"};